import {Component, Input} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

import {FilterConfig, FilterListValue, FilterState} from './table.interfaces';

@Component({
  selector: 'td[gp-table-filter]',
  template: `
    <select *ngIf="isSelect" class="form-control" [formControl]="control">
      <option *ngFor="let option of values"
              [value]="option.key"
              [selected]="option.key == value">
        {{ (option.name || option.key) | translate }}
      </option>
    </select>
    <input *ngIf="!isSelect" type="text" class="form-control"
           [formControl]="control" [placeholder]="placeholder"/>
  `
})
export class TableColumnFilter {

  @Input()
  public values: Array<FilterListValue> = null;

  @Input('gp-table-filter')
  public config: FilterConfig | Array<FilterConfig>;

  @Input('filter-placeholder')
  public placeholder: string;

  public filterChanged: Observable<FilterState>;

  public control: UntypedFormControl = new UntypedFormControl();

  get isSelect() {
    return this.values !== null;
  }

  get value() {
    return this.control.value;
  }

  set value(value: string) {
    this.control.setValue(value);
  }

  constructor() {
    this.filterChanged = this.control.valueChanges.pipe(
      map((value: string) => {
        return <FilterState>{
          config: this.config,
          value: value
        };
      }),
      distinctUntilChanged()
    );
  }
}
